import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const FloatingLanguageSwitcher = () => {
  const { language } = useLanguage();
  const [isChanging, setIsChanging] = useState(false);

  const handleLanguageSwitch = () => {
    if (isChanging) return;
    setIsChanging(true);
    
    const newLanguage = language === 'en-US' ? 'en-GB' : 'en-US';
    
    try {
      localStorage.setItem('amcardmate_language', newLanguage);
      window.location.reload();
    } catch (error) {
      console.error('Error switching language:', error);
      setIsChanging(false);
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div className="relative group">
        <button
          onClick={handleLanguageSwitch}
          disabled={isChanging}
          className="w-14 h-14 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Switch language"
        >
          <span className="text-btn font-bold">
            {language === 'en-GB' ? 'UK' : 'US'}
          </span>
        </button>
        
        {/* Tooltip */}
        <div className="absolute bottom-full right-0 mb-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
          <div className="bg-gray-800 text-white text-body-sm py-2 px-3 rounded-lg whitespace-nowrap">
            Currently: {language === 'en-GB' ? 'UK English' : 'US English'}
            <br />
            Click to switch to {language === 'en-US' ? 'UK English' : 'US English'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloatingLanguageSwitcher;